import React from "react";
export const Users = () => (
  <svg fill="none" viewBox="0 0 15 10">
    <path
      d="M10.01 4c1.111 0 1.992-.89 1.992-2 0-1.11-.88-2-1.992-2-1.111 0-2.002.89-2.002 2 0 1.11.89 2 2.002 2zM4.675 4c1.11 0 1.992-.89 1.992-2 0-1.11-.891-2-1.992-2a2 2 0 100 4zm0 1.33C3.113 5.33 0 6.11 0 7.67v1c0 .37.3.67.67.67h8.01c.37 0 .67-.3.67-.67v-1c-.01-1.56-3.123-2.34-4.674-2.34zm5.335 0c-.19 0-.41.01-.65.03l.03.03c.76.55 1.29 1.29 1.29 2.27v1c0 .23-.05.46-.12.67h3.454c.37 0 .67-.3.67-.67v-1c0-1.55-3.122-2.33-4.674-2.33z"
      fill="#192547"
    />
  </svg>
);
